/* global angular */
import { orderBy } from 'lodash';

export default function() {
  return function(items, dict, key, order = 'asc') {
    if (!dict || !Array.isArray(items)) return items;

    const records = items.map(item => {
      const params = { sort_value: item, item };
      if (dict && dict[item]) params.sort_value = dict[item];
      if (key && params.sort_value[key]) params.sort_value = params.sort_value[key];

      return params;
    });

    return orderBy(records, ['sort_value'], [order]).map(({ item }) => item);
  };
}



// WEBPACK FOOTER //
// ./src/app/filters/OrderArray.js